import React, { useState } from "react";
import TransactionItem from "./TransactionItem";
import CustomButton from "./CustomButton";
import ServiceTransaction from "../services/ServiceTransaction";
import { useServiceClient } from "../services/ServiceClientContext";

const TransactionList: React.FC = () => {
  const [transactions, setTransactions] = useState<ServiceTransaction[]>([]);
  const serviceClient = useServiceClient();

  React.useEffect(() => {
    const handler = (transaction: ServiceTransaction<any>) => {
      // handle update here
      setTransactions((prevTransactions) => [transaction, ...prevTransactions]);
    };
    const unsubscribe = serviceClient.onNewTransaction(handler);
    return () => {
      // Clean up the subscription when the component unmounts
      // rather than calling offUpdated directly, we use the unsubscribe function returned by onUpdated
      unsubscribe();
      //item.offUpdated(handler);
    };
  }, [serviceClient]);


  function handleClearButtonOnClick() {
    setTransactions([]);
  }

  function handleAddButtonOnClick() {
    const newTransaction: ServiceTransaction<boolean> = serviceClient.newServiceTransaction<boolean>("blah/1", "GET");
    newTransaction.Succeeded(true);
    setTransactions([newTransaction, ...transactions]);
  }

  return (
    <>
      <CustomButton label="Clear" onClick={handleClearButtonOnClick} />
      <CustomButton label="Add" onClick={handleAddButtonOnClick} />
      {transactions.map((transaction) => (
        <TransactionItem key={transaction.id} item={transaction} />
      ))}
    </>
  );
};

export default TransactionList;